export default __webpack_public_path__ + "static/media/07.617b8409.png";